import { ENTITY_OPTS_PROP, IEntityOptions, IModelClass } from '@briebug/ngrx-auto-entity';

export const resolveState = <Model>(type: IModelClass<Model>) => {
  const modelName = (type as unknown as { [ENTITY_OPTS_PROP]: IEntityOptions })[ENTITY_OPTS_PROP].modelName;
  const stateName = modelName.substring(0, 1).toLowerCase() + modelName.substring(1);
  const getState = <TState>(state: TState) => state[stateName as keyof TState];
  return getState;
};
